import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { resolveMobilePage } from "./registry";

function MobilePageMissing({ page, tenantKey }) {
  return (
    <Box
      minHeight="40vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={2}
      sx={{ color: "#55575C", fontWeight: 600 }}
    >
      Mobile page &quot;{page}&quot; is not configured
      {tenantKey ? ` for ${tenantKey}` : ""}.
    </Box>
  );
}

MobilePageMissing.propTypes = {
  page: PropTypes.string.isRequired,
  tenantKey: PropTypes.string,
};

MobilePageMissing.defaultProps = {
  tenantKey: "",
};

/**
 * Renders the tenant-specific mobile page when registered, otherwise shared default.
 */
export default function MobilePage({ page }) {
  const { tenantKey } = useStorefrontTenant();
  const PageComponent = resolveMobilePage(tenantKey, page);

  if (!PageComponent) {
    return <MobilePageMissing page={page} tenantKey={tenantKey} />;
  }

  return <PageComponent />;
}

MobilePage.propTypes = {
  page: PropTypes.oneOf([
    "home",
    "download",
    "qrDeal",
    "qrScan",
    "signIn",
    "catalog",
    "productDetail",
    "cart",
    "checkout",
    "portalHome",
    "portalOrders",
    "portalOrderDetail",
    "portalDistributorRequests",
    "portalDistributorRequestDetail",
    "portalDistributorCustomers",
    "portalValveBodies",
    "portalValveBodyDetail",
    "portalCoreReturns",
    "portalCoreReturn",
    "portalWarrantyCreate",
    "portalWarrantyClaim",
    "portalWarrantyChat",
    "portalSupport",
    "portalSupportCompose",
    "portalSupportThread",
    "portalProfile",
    "portalAddresses",
  ]).isRequired,
};
